import React from "react";
import { Select } from "antd";
import {
  FormItem,
  InputItem,
  DatePickerItem,
  SelectItem,
} from "../../../Components/Items";
import { ESTATUS_REPSE_OPTIONS } from "../../../constants/nomina/repse";

const { Option } = Select;

/**
 * Bloque "Aviso de Registro REPSE" del alta y la edición de un Registro
 * Patronal. Es un solo componente para que los dos modales no se desincronicen.
 *
 * Alimenta las columnas "Folio del registro REPSE", "Fecha del registro REPSE",
 * "Estatus del registro REPSE" y "Actividad económica especializada manifestada
 * en REPSE" de las DOS hojas de la plantilla oficial de subcontratación
 * (Pages/Panel/ReportesNomina/ReporteRepse.js).
 *
 * Los folios ICSOE NO van aquí: cambian en cada presentación mensual y se
 * capturan en la pantalla del reporte.
 */
const CamposRepse = () => (
  <>
    <h3 style={{ marginTop: 16, marginBottom: 8 }}>Aviso de Registro REPSE</h3>

    <FormItem
      name="folioRepse"
      label="Folio del Registro REPSE"
      margin
      tooltip="Es el folio que viene en el acuse de Aviso de Registro REPSE. Ejemplo: AR99990/2021"
    >
      <InputItem placeholder="Ej: AR99990/2021" />
    </FormItem>

    <FormItem name="fechaRepse" label="Fecha del Registro REPSE" margin>
      <DatePickerItem placeholder="Fecha del registro" style={{ width: "100%" }} />
    </FormItem>

    <FormItem name="estatusRepse" label="Estatus del Registro REPSE" margin>
      <SelectItem placeholder="Estatus del registro" allowClear>
        {ESTATUS_REPSE_OPTIONS.map((value) => (
          <Option value={value} key={value}>
            {value}
          </Option>
        ))}
      </SelectItem>
    </FormItem>

    <FormItem
      name="actividadRepse"
      label="Actividad Económica Especializada"
      margin
      tooltip="Tal como se encuentra registrada en el Aviso de Registro REPSE"
    >
      <InputItem placeholder="Actividad manifestada en REPSE" />
    </FormItem>
  </>
);

export default CamposRepse;
